import React, {ReactElement} from 'react';
import StyledInput from '../../../../../../components/StyledInput';
import StyledButton from '../../../../../../components/StyledButton';
import {Props} from './Props';
import {State} from './State';

class NotificationPane extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            message: '',
        };
    }

    render(): ReactElement {
        const {onSaveNewNotificationMessage} = this.props;
        const {message} = this.state;

        return (
            <>
                <p>
                    Met het onderstaand veld is het mogelijk om een notificatie naar de gebruikers van de NDW Viewer te
                    sturen. Wanneer het veld leeggemaakt is en je op opslaan drukt zal de laatste notificatie verborgen
                    worden.
                </p>

                <br />

                <StyledInput
                    type={'text'}
                    value={message}
                    changeInput={(value) => this.handleMessageInputChange(value)}
                    placeholder={'Notificatie bericht'}
                    submitInput={() => onSaveNewNotificationMessage(message)}
                />

                <StyledButton
                    onPress={() => onSaveNewNotificationMessage(message)}
                    aria-label="Opslaan"
                    title={
                        <>
                            <span className="fas fa-save" /> Opslaan
                        </>
                    }
                />
            </>
        );
    }

    private handleMessageInputChange = (message: string) => {
        this.setState({
            message,
        });
    };
}

export default NotificationPane;
